import { CompactTable } from '@table-library/react-table-library/compact';
import { useTheme } from '@table-library/react-table-library/theme';
import { getTheme } from '@table-library/react-table-library/baseline';
import { usePagination } from "@table-library/react-table-library/pagination";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { FiEye, FiPlus, FiSearch, FiShield } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { getAdminList } from "../../store/user/userActions";
import { getImage } from "../../utils";
import { TablePagination } from "../../components/global/table-pagination";
import Styles from './users.module.scss';

const AdministratorsList = () => {
    const [search, setSearch] = useState("");
    const [nodes, setNodes] = useState([]);
    const dispatch = useDispatch();

    const handleSearch = (event) => {
        setSearch(event.target.value);
    };

    useEffect(() => {
        dispatch(getAdminList())
            .unwrap()
            .then((list) => setNodes(Array.isArray(list) ? list : []));
    }, [dispatch]);

    const COLUMNS = [
        {
            onHeaderCell: {
                maxWidth: "50px"
            },
            label: 'Avatar',
            class: "avatar",
            renderCell: (item) => <img className={Styles.avatar} src={getImage(item.avatar, "AVATAR")} />
        },
        {
            label: 'Firstname',
            renderCell: (item) => item.firstName
        },
        {
            label: 'Lastname',
            renderCell: (item) => item.lastName
        },
        {
            label: 'Email',
            renderCell: (item) => item.email
        },
        {
            label: '',
            renderCell: (item) => (
                <Link className={Styles.viewBtn} to={`/users/user/${item._id}`}>
                    <FiEye />
                    <span>View</span>
                </Link>
            )
        }
    ];

    const theme = useTheme([getTheme(), {
        HeaderRow: `color: #191D51;`,
        HeaderCell: `width: auto;`,
        Cell: `width: auto;`,
    }]);

    let data = { nodes };
    data = {
        nodes: data.nodes.filter((item) =>
            item.firstName.toLowerCase().includes(search.toLowerCase()) ||
            item.lastName.toLowerCase().includes(search.toLowerCase()) ||
            item.email.toLowerCase().includes(search.toLowerCase()) ||
            (item.phone && item.phone.toLowerCase().includes(search.toLowerCase()))
        )
    };

    const pagination = usePagination(data, {
        state: {
            page: 0,
            size: 5,
        }
    });

    const pageButtonCount = 2;
    const totalPages = pagination.state.getTotalPages(data.nodes);
    const pages = pagination.state.getPages(data.nodes);
    const navigate = useNavigate();

    return (
        <div className={Styles.tableContainer}>
            <div className="mb-5 rounded-2xl border border-slate-200 bg-slate-50 p-4 sm:p-5">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                    <div className="flex items-center gap-3">
                        <div className="grid h-10 w-10 place-items-center rounded-xl bg-nt-blue/10 text-nt-blue">
                            <FiShield size={18} />
                        </div>
                        <div>
                            <h2 className="text-xl font-semibold text-nt-blue">Administrators</h2>
                            <p className="text-sm text-nt-grey">Manage access for administrator accounts</p>
                        </div>
                    </div>
                    <button
                        className="inline-flex items-center justify-center gap-2 rounded-lg bg-nt-blue px-4 py-2 text-sm font-semibold text-white transition-opacity hover:opacity-95"
                        onClick={() => navigate("/create/admin")}
                    >
                        <FiPlus size={16} />
                        <span>Add Administrator</span>
                    </button>
                </div>
            </div>

            <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <p className="text-sm text-nt-grey">
                    {data.nodes.length} result{data.nodes.length === 1 ? "" : "s"}
                </p>
                <label htmlFor="search" className="relative w-full sm:w-[300px]">
                    <FiSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-nt-grey" size={16} />
                    <input
                        id="search"
                        type="text"
                        placeholder="Search administrators..."
                        className="w-full rounded-lg border border-slate-200 bg-white py-2 pl-9 pr-3 text-sm outline-none transition focus:border-nt-blue focus:ring-2 focus:ring-nt-blue/10"
                        value={search}
                        onChange={handleSearch}
                    />
                </label>
            </div>

            <CompactTable columns={COLUMNS} data={data} theme={theme} pagination={pagination} key={"_id"} />

            {totalPages > 0 ? <TablePagination
                pageButtonCount={pageButtonCount}
                totalPages={totalPages}
                pagination={pagination}
                pages={pages}
            /> : null}
        </div>
    );
};

export { AdministratorsList };
